import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'dashboard',
        path: `${APP_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'roles',
        path: `${APP_PREFIX_PATH}/roles`,
        component: React.lazy(() => import('views/app-views/roles')),
    },
    {
        key: 'usuarios',
        path: `${APP_PREFIX_PATH}/usuarios`,
        component: React.lazy(() => import('views/app-views/usuarios')),
    },
    {
        key: 'grupos',
        path: `${APP_PREFIX_PATH}/grupos`,
        component: React.lazy(() => import('views/app-views/grupos')),
    },
    {
        key: 'vehiculos',
        path: `${APP_PREFIX_PATH}/vehiculos`,
        component: React.lazy(() => import('views/app-views/vehiculos')),
    },
    {
        key: 'categoriasdeproductos',
        path: `${APP_PREFIX_PATH}/productcategories`,
        component: React.lazy(() => import('views/app-views/productcategories')),
    },
    {
        key: 'unidades',
        path: `${APP_PREFIX_PATH}/unidades`,
        component: React.lazy(() => import('views/app-views/unidades')),
    },
    {
        key: 'materiales',
        path: `${APP_PREFIX_PATH}/materiales`,
        component: React.lazy(() => import('views/app-views/materiales')),
    },
    {
        key: 'proveedores',
        path: `${APP_PREFIX_PATH}/proveedores`,
        component: React.lazy(() => import('views/app-views/proveedores')),
    },
    {
        key: 'ordenesdecompra',
        path: `${APP_PREFIX_PATH}/ordenesdecompra`,
        component: React.lazy(() => import('views/app-views/ordenesdecompra')),
    },
    {
        key: 'compras',
        path: `${APP_PREFIX_PATH}/compras`,
        component: React.lazy(() => import('views/app-views/buys')),
    },
    {
        key: 'entradas',
        path: `${APP_PREFIX_PATH}/entradas`,
        component: React.lazy(() => import('views/app-views/entradas')),
    },
    {
        key: 'almacenes',
        path: `${APP_PREFIX_PATH}/warehouses`,
        component: React.lazy(() => import('views/app-views/warehouses')),
    },
    {
        key: 'especificaciones',
        path: `${APP_PREFIX_PATH}/specs`,
        component: React.lazy(() => import('views/app-views/specs')),
    },
    {
        key: 'servicios',
        path: `${APP_PREFIX_PATH}/services`,
        component: React.lazy(() => import('views/app-views/services')),
    },
    {
        key: 'mantenimientos',
        path: `${APP_PREFIX_PATH}/maintenances`,
        component: React.lazy(() => import('views/app-views/maintenances')),
    },
    {
        key: 'ordenesdemantenimiento',
        path: `${APP_PREFIX_PATH}/maintenanceOrders`,
        component: React.lazy(() => import('views/app-views/maintenanceOrder')),
    },
    {
        key: 'inventario',
        path: `${APP_PREFIX_PATH}/inventario`,
        component: React.lazy(() => import('views/app-views/inventory')),
    },
    {
        key: 'salidas',
        path: `${APP_PREFIX_PATH}/salidas`,
        component: React.lazy(() => import('views/app-views/dispatch')),
    },
    {
        key: 'salidasalmacen',
        path: `${APP_PREFIX_PATH}/salidasalmacen`,
        component: React.lazy(() => import('views/app-views/warehousedispatch')),
    },
    {
        key: 'marcas',
        path: `${APP_PREFIX_PATH}/brands`,
        component: React.lazy(() => import('views/app-views/brands')),
    },
    {
        key: 'traspasos',
        path: `${APP_PREFIX_PATH}/transfers`,
        component: React.lazy(() => import('views/app-views/transfers')),
    },
    {
        key: 'modulotrabajomecanicos',
        path: `${APP_PREFIX_PATH}/modulotrabajomecanicos`,
        component: React.lazy(() => import('views/app-views/moduloTrabajo')),
    },
    {
        key: 'programademantenimiento',
        path: `${APP_PREFIX_PATH}/maintenanceprogram`,
        component: React.lazy(() => import('views/app-views/maintenanceProgram')),
    },
    {
        key: 'reportecombustible',
        path: `${APP_PREFIX_PATH}/fuelreport`,
        component: React.lazy(() => import('views/app-views/fuelReport')),
    },
    {
        key: 'reportecompras',
        path: `${APP_PREFIX_PATH}/buyreports`,
        component: React.lazy(() => import('views/app-views/buyreport')),
    }
]